export default {
  zh: {
    "menberTitle": "成员",
    "searchText": "搜索",
    "isSend": (txt) => {
      return `Members(${txt})`
    },
    "searchPolad": "搜索昵称或ID",
    "searchEmptyTrxt": "没有搜索结果",
    "joinDateText": "加入日期:",
    "cancel": '关闭',
    "confirm": '确定',
    "tips": "提示",
    "remove": (txt, id) => {
      return `从公会中移除${txt}（ID：${id}）`
    },
    "removeText":"移除",
    "remove_toast2":"移除成功",
    "remove_toast3":"移除失败，请稍后重试",
    "remove_toast1":"你已不是该公会的公会长，无法移除公会成员",
  },
  en: {
    "menberTitle": "Members",
    "searchText": "Search",
    "isSend": (txt) => {
      return `Members(${txt})`
    },
    "searchPolad": "Search by nickname or ID",
    "searchEmptyTrxt": "No search result",
    "joinDateText": "Join date:",
    "cancel": 'Cancel',
    "confirm": 'Confirm',
    "tips": "Tips",
    "remove": (txt, id) => {
      return `Remove ${txt} (ID:${id}) out from agency`
    },
    "removeText":"Remove",
    "remove_toast2":"Remove successfully",
    "remove_toast3":"Remove failed, please try again later",
    "remove_toast1":"You are no longer the agency leader and cannot be removed.",
  },
  ar: {
    "menberTitle": "Members",
    "searchText": "يبحث",
    "isSend": (txt) => {
      return `(${txt})عضو`
    },
    "searchPolad": " البحث عن اللقب أو الهوية",
    "searchEmptyTrxt": "لا نتائج للبحث",
    "joinDateText": "تاريخ الانضمام:",
    "cancel": 'يلغي',
    "confirm": 'نعم',
    "tips": "نصيحة",
    "remove": (txt, id) => {
      return `إزالة ${txt} من الوكالة (ID: ${id})`
    },
    "removeText":"إزالة ",
    "remove_toast2":"تم الإزالة بنجاح",
    "remove_toast3":"فشلت عملية الإزالة، يرجى المحاولة مرة أخرى لاحقًا",
    "remove_toast1":"لم تعد الوكيل ولا يمكنك إزالة أعضاء الوكالة.",
  },
  tr: {
    "menberTitle": "Üyeler",
    "searchText": "Ara",
    "isSend": (txt) => {
      return `Üyeler(${txt})`
    },
    "searchPolad": "Takma Ad veya Kimliğe Göre Arayın",
    "searchEmptyTrxt": "Arama Sonucu Yok",
    "joinDateText": "Katılma Tarihi:",
    "cancel": 'Lütfen',
    "confirm": 'Onayla',
    "tips": "Uyarı",
    "remove": (txt, id) => {
      return `${txt} (ID:${id}) adlı kişiyi ajanstan çıkarttı`
    },
    "removeText":"Kaldır",
    "remove_toast2":"Başarıyla Kaldırıldı",
    "remove_toast3":"Kaldırma başarısız oldu, lütfen daha sonra tekrar deneyin",
    "remove_toast1":"Artık ajans lideri değilsiniz ve görevden alınamazsınız.",
  },
  pt: {
    "menberTitle": "Membros",
    "searchText": "Pesquisar",
    "isSend": (txt) => {
      return `Membros(${txt})`
    },
    "searchPolad": "Pesquisar por apelido ou ID",
    "searchEmptyTrxt": "Sem resultados de pesquisa",
    "joinDateText": "Data de adesão:",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "tips": "Dicas",
    "remove": (txt, id) => {
      return `Remover ${txt} (ID:${id}) da agência`
    },
    "removeText": "Remover",
    "remove_toast2": "Removido com sucesso",
    "remove_toast3": "Falha ao remover, tente novamente mais tarde",
    "remove_toast1": "Você não é mais o líder da agência e não pode ser removido."
  },
  id: {
    "menberTitle": "Anggota",
    "searchText": "Cari",
    "isSend": (txt) => {
      return `Anggota(${txt})`
    },
    "searchPolad": "Cari dengan nama panggilan atau ID",
    "searchEmptyTrxt": "Tidak ada hasil pencarian",
    "joinDateText": "Tanggal Bergabung:",
    "cancel": "Batal",
    "confirm": "Konfirmasi",
    "tips": "Tips",
    "remove": (txt, id) => {
      return `Hapus ${txt} (ID:${id}) dari agensi`
    },
    "removeText": "Hapus",
    "remove_toast2": "Berhasil dihapus",
    "remove_toast3": "Gagal menghapus, coba lagi nanti",
    "remove_toast1": "Anda tidak lagi menjadi pemimpin agensi dan tidak dapat dihapus."
  },
  uz: {
    "menberTitle": "A'zolar",
    "searchText": "Qidirish",
    "isSend": (txt) => {
      return `A'zolar(${txt})`
    },
    "searchPolad": "Nick yoki ID bo'yicha qidirish",
    "searchEmptyTrxt": "Qidiruv natijalari yo'q",
    "joinDateText": "Qo'shilgan sana:",
    "cancel": "Bekor qilish",
    "confirm": "Tasdiqlash",
    "tips": "Maslahatlar",
    "remove": (txt, id) => {
      return `${txt} (ID:${id}) ni agentlikdan olib tashlash`
    },
    "removeText": "Olib tashlash",
    "remove_toast2": "Muvaffaqiyatli olib tashlandi",
    "remove_toast3": "Olib tashlashda xato yuz berdi, iltimos keyinroq qayta urinib ko'ring",
    "remove_toast1": "Siz endi agentlik rahbari emassiz va olib tashlanolmaysiz."
  },
  ru: {
    "menberTitle": "Члены",
    "searchText": "Поиск",
    "isSend": (txt) => {
      return `Члены(${txt})`
    },
    "searchPolad": "Поиск по нику или ID",
    "searchEmptyTrxt": "Нет результатов поиска",
    "joinDateText": "Дата вступления:",
    "cancel": "Отмена",
    "confirm": "Подтвердить",
    "tips": "Советы",
    "remove": (txt, id) => {
      return `Удалить ${txt} (ID:${id}) из агентства`
    },
    "removeText": "Удалить",
    "remove_toast2": "Удалено успешно",
    "remove_toast3": "Ошибка при удалении, попробуйте позже",
    "remove_toast1": "Вы больше не являетесь лидером агентства и не можете быть удалены."
  },
  fa: {
    "menberTitle": "اعضا",
    "searchText": "جستجو",
    "isSend": (txt) => {
      return `اعضا(${txt})`
    },
    "searchPolad": "جستجو با نام مستعار یا ID",
    "searchEmptyTrxt": "نتیجه‌ای برای جستجو یافت نشد",
    "joinDateText": "تاریخ پیوستن:",
    "cancel": "لغو",
    "confirm": "تأیید",
    "tips": "نکات",
    "remove": (txt, id) => {
      return `${txt} (ID:${id}) را از آژانس حذف کنید`
    },
    "removeText": "حذف",
    "remove_toast2": "با موفقیت حذف شد",
    "remove_toast3": "حذف ناموفق بود، لطفاً بعداً دوباره تلاش کنید",
    "remove_toast1": "شما دیگر رهبر آژانس نیستید و نمی‌توانید حذف شوید."
  }
}



// WEBPACK FOOTER //
// src/pages/app/host-member/lang.js